import {createSelector} from 'reselect';
import {PersonStateType} from 'module/Person/reducer/PersonReducer';

export const selPersonById = (state: PersonStateType) => state.Person.byId;
export const selPersonAllIds = (state: PersonStateType) => state.Person.allIds;
export const selPersonTemplateId = (state: PersonStateType) => state.Person.templateId;
export const selPersonSingleChoiceMode = (state: PersonStateType) => state.Person.singleChoiceMode
export const selHiddenPersNrs = createSelector(
	selPersonById,
	(byId) => Object.values(byId).flatMap(p => p?.hidden ? [p.persNr] : []),
)
export const _selVisiblePersNrsRaw = createSelector(
	(state: PersonStateType) => state.Person.visibleIds,
	selHiddenPersNrs,
	(visibleIds, hiddenIds) => visibleIds.filter(id => !hiddenIds.includes(id)),
)
export const selVisiblePersNrs = createSelector(
	selPersonAllIds,
	_selVisiblePersNrsRaw,
	selHiddenPersNrs,
	(all, visible, hidden) => {
		if (visible.length) {
			return visible // hidden already filtered
		} else {
			return all.filter(id => !hidden.includes(id))
		}
	})
export const selSelectedPersNr = (state: PersonStateType) => selVisiblePersNrs(state)[0]

export const selPersonSelected = createSelector(
	selPersonSingleChoiceMode,
	selVisiblePersNrs,
	selPersonById,
	(singleChoiceMode, persNrs, byId) => singleChoiceMode && byId[persNrs[0]],
)
export const selPersonFilterActive = (state: PersonStateType) => !state.Person.singleChoiceMode && !!_selVisiblePersNrsRaw(state).length

export const selVisiblePersNrObj = createSelector(
	selVisiblePersNrs,
	visiblePersNrs =>
		visiblePersNrs.reduce<Record<number, boolean>>((result, persNr) => {
			result[persNr] = true;
			return result;
		}, {}),
)

